var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilecircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 13.3874C8.51666 13.3874 9.89332 12.8099 10.9317 11.859C10.8733 11.3107 10.5233 10.774 9.89916 10.354C8.31249 9.29237 5.69916 9.29237 4.10082 10.354C3.47666 10.774 3.12666 11.3107 3.06832 11.859C4.10666 12.8099 5.48332 13.3874 6.99999 13.3874ZM6.99999 13.3874C10.2217 13.3874 12.8333 10.7757 12.8333 7.55404C12.8333 4.33238 10.2217 1.7207 6.99999 1.7207C3.77833 1.7207 1.16666 4.33238 1.16666 7.55404C1.16666 10.7757 3.77833 13.3874 6.99999 13.3874ZM7.06999 8.00904C7.02916 8.0032 6.97666 8.0032 6.92999 8.00904C5.90332 7.97404 5.08666 7.13404 5.08666 6.10154C5.08666 5.0457 5.93832 4.1882 6.99999 4.1882C8.05582 4.1882 8.91332 5.0457 8.91332 6.10154C8.90749 7.13404 8.09666 7.97404 7.06999 8.00904Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilecircle);
export default __webpack_public_path__ + "static/media/profilecircle.e9eff112f91b7de20b8a84a19a0fdb68.svg";
export { ForwardRef as ReactComponent };